/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimulationKeyFigureValue
 */
export interface SimulationKeyFigureValue {
    /**
     * 
     * @type {number}
     * @memberof SimulationKeyFigureValue
     */
    fileValue?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationKeyFigureValue
     */
    simulationValue?: number | null;
}

/**
 * Check if a given object implements the SimulationKeyFigureValue interface.
 */
export function instanceOfSimulationKeyFigureValue(value: object): value is SimulationKeyFigureValue {
    return true;
}

export function SimulationKeyFigureValueFromJSON(json: any): SimulationKeyFigureValue {
    return SimulationKeyFigureValueFromJSONTyped(json, false);
}

export function SimulationKeyFigureValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationKeyFigureValue {
    if (json == null) {
        return json;
    }
    return {
        
        'fileValue': json['fileValue'] == null ? undefined : json['fileValue'],
        'simulationValue': json['simulationValue'] == null ? undefined : json['simulationValue'],
    };
}

export function SimulationKeyFigureValueToJSON(json: any): SimulationKeyFigureValue {
    return SimulationKeyFigureValueToJSONTyped(json, false);
}

export function SimulationKeyFigureValueToJSONTyped(value?: SimulationKeyFigureValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileValue': value['fileValue'],
        'simulationValue': value['simulationValue'],
    };
}

